import PropertyType from '../Modifiers/PropertyType.js';

var ThemeBlockBackgroundValue = new PropertyType({
  name: 'BlockBackgroundValue',
  propertyFromApi: 'block-background-value',
  convertValueToCssPropertiesFunction: function convertValueToCssPropertiesFunction(value) {
    // console.log('theme value', value)
    return "background-color: " + value + "; backdrop-filter: blur(8px);";
  },
  selector: '.block',
  defaultValue: '#FFFFFF',
  cssVariable: '--block-background-color',
  cssVariableFunction: function cssVariableFunction(value) {
    return value;
  },
  convertToRgb: true
}, 'theme');
var FormBlockBackgroundValue = new PropertyType({
  name: 'BlockBackgroundValue',
  propertyFromApi: 'block-background-value',
  convertValueToCssPropertiesFunction: function convertValueToCssPropertiesFunction(value) {
    // console.log('form value', value)
    return "background-color: " + value + "; backdrop-filter: blur(8px);";
  },
  selector: '.block',
  defaultValue: '#FFFFFF',
  cssVariable: '--block-background-color',
  cssVariableFunction: function cssVariableFunction(value) {
    return value;
  },
  convertToRgb: true
}, 'form');

export { FormBlockBackgroundValue, ThemeBlockBackgroundValue };
//# sourceMappingURL=BlockBackgroundValue.js.map
